import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { initSentry } from "./lib/observability/sentry";
import { initI18n } from "./i18n";
import "./styles/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

void (async () => {
  await initI18n();
  await initSentry();
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
})();
